export default "__VITE_ASSET__Bh7RW$NV__"